import COLORS from 'constants/colorOptions';

export default {
  data: COLORS,
};
